/**
 * Runtime environment configuration.
 *
 * Vite exposes anything prefixed with VITE_ as import.meta.env.VITE_*.
 * Local override via .env.local.
 */
export const env = {
  apiBaseUrl: (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? '/api',
  appName: 'DistroOps',
  appVersion: '0.1.0',
  defaultLocale: 'en' as const,
  supportedLocales: ['en', 'ur', 'ar'] as const,
  // Tenant header name — backend reads this for cross-tenant super-admin context
  tenantHeader: 'X-Company-Id',
  // Which app this build is: 'tenant' (portal) or 'admin' (admin console).
  // Backend login uses this to keep platform accounts out of the tenant portal
  // and tenant accounts out of the admin console.
  appKind: (import.meta.env.VITE_APP_KIND as string | undefined) ?? 'tenant',
} as const

export type SupportedLocale = (typeof env.supportedLocales)[number]
